import { c as _c } from "react/compiler-runtime";
import type { XtdhMetricsProps } from "../types";
import { XtdhStatCard } from "./XtdhStatCard";
export function XtdhMetricsSection(t0) {
  const $ = _c(11);
  const {
    multiplier,
    producedXtdhRate,
    granted
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 id="base-xtdh-metrics-heading" className="tw-sr-only">Base xTDH Metrics</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== multiplier) {
    t2 = <XtdhStatCard label="Multiplier" tooltip="Current xTDH multiplier applied to your TDH Rate" value={multiplier} subtext="x" />;
    $[1] = multiplier;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== producedXtdhRate) {
    t3 = <XtdhStatCard label="xTDH Rate" tooltip={"Total xTDH you can generate per day (TDH Rate \xD7 Multiplier)"} value={producedXtdhRate} subtext="/day" />;
    $[3] = producedXtdhRate;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== granted) {
    t4 = <XtdhStatCard label="Granted" tooltip="Total xTDH granted to you per day" value={granted} subtext="/day" />;
    $[5] = granted;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <section aria-labelledby="base-xtdh-metrics-heading" className="tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-3">{t1}{t2}{t3}{t4}</section>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}